import { Collapse, Row, FormInstance, Col, Card } from 'antd';
import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import Title from 'components/Title';
import { TpAuthorizationResponse } from 'services/thirdParty';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ParListSelect from 'components/ParListSelect';
import FormInput from 'components/FormInput';

const { Panel } = Collapse;

export type AccordSFSProps = {
  form: FormInstance;
  tpauthlist: TpAuthorizationResponse[];
};

const AccordSFS = ({ form, tpauthlist }: AccordSFSProps) => {
  let tpAuthListActive = tpauthlist?.filter((tp) => tp.authstatus === 'ACTIVE');

  let tpAuthList = tpauthlist?.filter((tp) => tp.authstatus !== 'ACTIVE');

  let tpAuthDetails = tpAuthListActive?.flatMap((tp) => tp.authDetail);

  return (
    <>
      <Card
        title={
          <GetLabel
            label="SITUATION ADMINISTRATIVE DU TIERS"
            style={{ fontWeight: 'bold', paddingLeft: 15 }}
          />
        }
        style={{
          width: '100%',
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          marginBottom: 10,
        }}
        bordered
      >
        {tpAuthListActive?.map((auth) => {
          let authlistactive = auth ? 'OUI' : 'NON';
          let date = 'Du ' + auth.startdate + ' au ' + auth.enddate;

          return (
            <Row key={auth.authid}>
              <Col xs={8}>
                <Row>
                  <Col xs={24}>
                    <FormInput
                      name="authlistactive"
                      initialValue={authlistactive}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={24}>
                    <FormInput name="date" initialValue={date} />
                  </Col>
                </Row>
                <Row >
                  <Col xs={24}>
                    <FormInput name="accordcard" initialValue="OUI" />
                  </Col>
                </Row>
                <Row>
                  <Col xs={24}>
                    <FormInput
                      name="authdate"
                      initialValue={
                        'Du ' + auth.startdate + ' au ' + auth.enddate
                      }
                    />
                  </Col>
                </Row>
                {tpAuthDetails?.map((detail,index) => {
                  let startdate =
                    detail.startdate !== null ? 'Du ' + detail.startdate : '';
                  let enddate =
                    detail.startdate !== null ? ' au ' + detail.enddate : '';

                  return (
                    <Row key={detail.authid}>
                      <Col xs={24}>
                        <FormInput
                          name={detail.offerlabel}
                          initialValue={startdate + enddate}
                        />
                      </Col>
                    </Row>
                  );
                })}
                <Col xs={12}>
                  <FormInput name="limitcontrol">
                    <ParListSelect parcode="LIMITCTRL" />
                  </FormInput>
                </Col>
              </Col>
            </Row>
          );
        })}
      </Card>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined
            style={{ fontSize: 24, float: 'left' }}
            rotate={isActive ? 90 : 0}
          />
        )}
        expandIconPosition="left"
        defaultActiveKey={['0', '1']}
      >
        {tpAuthList?.map((auth, index) => {
          let authlistactive = auth ? 'OUI' : 'NON';
          let date = 'Du ' + auth.startdate + ' au ' + auth.enddate;
          return (
            <Panel
              header={
                <Title
                  level={5}
                  comcode="HISTORIQUE ACCORD DE FINANCEMENT"
                ></Title>
              }
              key={index}
              style={{
                marginBottom: 24,
                overflow: 'hidden',
                background: '#f7f7f7',
                border: 10,
                borderRadius: 2,
                boxShadow:
                  'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
              }}
            >
              <Row key={auth.authid}>
                <Col xs={8}>
                  <Row>
                    <Col xs={24}>
                      <FormInput
                        name="authlistactive"
                        initialValue={authlistactive}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24}>
                      <FormInput name="date" initialValue={date} />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24}>
                      <FormInput name="accordcard" initialValue="OUI" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24}>
                      <FormInput
                        name="authdate"
                        initialValue={
                          'Du ' + auth.startdate + ' au ' + auth.enddate
                        }
                      />
                    </Col>
                  </Row>
                  {tpAuthDetails?.map((detail) => {
                    let startdate =
                      detail.startdate !== null ? 'Du ' + detail.startdate : '';
                    let enddate =
                      detail.startdate !== null ? ' au ' + detail.enddate : '';

                    return (
                      <Row style={{ marginBottom: '5%' }} key={detail.authid}>
                        <Col xs={24}>
                          <FormInput
                            name={detail.offerlabel}
                            initialValue={startdate + enddate}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                  <Col xs={12}>
                    <FormInput name="limitcontrol">
                      <ParListSelect parcode="LIMITCTRL" />
                    </FormInput>
                  </Col>
                </Col>
              </Row>
              {/* <Row>
                <Col xs={12}>
                  <FormInput name="limitcontrol">
                    <ParListSelect parcode="LIMITCTRL" />
                  </FormInput>
                </Col>
              </Row> */}
            </Panel>
          );
        })}
      </Collapse>
    </>
  );
};

export default AccordSFS;
